import React from 'react';
import { useEffect, useState } from 'react';

import CardCheckBox from './CardCheckBox';
import CardInformation from '../../join-commute/payment-screen/card-information/CardInformation';
import Close from '../../_styles/images/close-icon-green.svg';
import FederalComponent from '../../join-commute/payment-screen/federal-component/FederalComponent';
import creditCardService from '../../shared/credit-card/creditCardService';
import { initDate } from '../../join-commute/helpers/commonHelper';
import analyticsService from '../../shared/analytics/analytics-service';
import LegalCopy from './LegalCopy';
import { TAB_KEY_CODE } from '../../shared/helpers/accessibilityHelpers';
import FederalOrCommuterRadio from '../../join-commute/payment-screen/FederalOrCommuterRadio';
import RetailOrCommuterRadio from '../../join-commute/payment-screen/RetailOrCommuterRadio';
import CardMessage from './CardMessage';
import CardReplacementConfirmPopup from './CardReplacementConfirmPopup';

function AddCard(props) {
  const [cardNumber, updateCardNumber] = useState('');
  const [cardValid, updateCardValid] = useState(true);
  const [expirationDate, updateExpirationDate] = useState(initDate);
  const [cvv, updateCvv] = useState('');
  const [cvvValid, updateCvvValid] = useState(true);
  const [zip, updateZip] = useState('');
  const [zipValid, updateZipValid] = useState(true);
  const [dateValid, updateDateValid] = useState(true);
  const [cardType, updateCardType] = useState('');
  const [buttonDisabled, updateButtonDisabled] = useState(true);
  const [isFederal, updateIsFederal] = useState(null);
  const [showFederalComponent, updateShowFederalComponent] = useState(null);
  const [isCvvDisabled, updateCvvDisabled] = useState(true);
  const [checked, updateChecked] = useState(false);
  const [showSetDefault, updateShowSetDefault] = useState(false);
  const [showSetBackup, updateShowSetBackup] = useState(false);
  const [disableCheckbox, updateDisableCheckbox] = useState(false);
  const [showCheckbox, updateShowCheckbox] = useState(false);
  const [authorizedAmount, updateAuthorizedAmount] = useState();
  const [isAmountValid, updateIsAmountValid] = useState(true);
  const [mayBeFedCommuter, updateMayBeFedCommuter] = useState(null);
  const [mayBeRetailCommuter, updateMayBeRetailCommuter] = useState(null);
  const [isCommuter, updateIsCommuter] = useState(null);
  const [isRetail, updateIsRetail] = useState(null);
  const [showFederalCommuteRadio, updateShowFederalCommuteRadio] = useState(false);
  const [showRetailCommuteRadio, updateShowRetailCommuteRadio] = useState(false);
  const [fedComuCardOnFile, updateFedComuCardOnFile] = useState(false);
  const [showConfirm, updateShowConfirm] = useState(false);
 //const [showBothChekbox, updateShowBothChekbox] = useState(false);
  const [secondaryChecked, setSecondaryChecked] = useState(false);
  const [showReplacementConfirm, updateShowReplacementConfirm] = useState(false);

  useEffect(() => {
    analyticsService.getPageName({ 'pagename': 'payment/add new card' });
    return () => {
      updateCardNumber('');
      updateCardValid(true);
      updateExpirationDate(initDate);
      updateCvv('');
      updateCvvValid(true);
      updateZip('');
      updateZipValid(true);
      updateDateValid(true);
      updateCardType('');
      updateButtonDisabled(true);
      updateIsFederal(null);
      updateCvvDisabled(true);
      updateChecked(false);
      updateShowSetDefault(false);
      updateShowSetBackup(false);
      updateDisableCheckbox(false);
      updateShowCheckbox(false);
      updateAuthorizedAmount();
      updateIsAmountValid(true);
      updateIsCommuter(null);
      if (props.cardDetails && props.cardDetails.primaryCards && props.cardDetails.primaryCards[0] && (props.cardDetails.primaryCards[0].isCommuterBenefitCard || props.cardDetails.primaryCards[0].isFederalBenefitCard)) {
        updateFedComuCardOnFile(true);
      }
    };
  }, []);

  function onDateChange(type, value) {
    updateExpirationDate({
      ...expirationDate,
      [type]: value
    });
  }

  function toggleCheckBox() {
    if (!checked) {
      analyticsService.analyticsProcessEvent({
        "event": "click_generic",
        "context": {
          "event_action": showSetBackup ? "make backup card" : "make default card"
        }
      });
      setSecondaryChecked(false)
    }
    updateChecked(!checked);
  }

  function checkForExistingPrimaryRetail() {
    if (props.cardDetails.retail > 0 && (props.cardDetails.retailCards && props.cardDetails.retailCards[0] && props.cardDetails.retailCards[0].isPrimary) && (props.cardDetails.primaryCards && props.cardDetails.primaryCards[0] && props.cardDetails.primaryCards[0].isPrimary && !props.cardDetails.primaryCards[0].isFederalBenefitCard && !props.cardDetails.primaryCards[0].isCommuterBenefitCard)) {
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => {
    updateShowCheckbox(false);
    updateShowSetDefault(false);
    updateDisableCheckbox(false);
    updateChecked(false);
    updateShowSetBackup(false);
    updateShowConfirm(false);
   // updateShowBothChekbox(false);
    setSecondaryChecked(false)
    if (props.cardDetails) {
      //delete card scenario
      if (props.isDeleteScenario) {
        if (isRetail && !checkForExistingPrimaryRetail()) {
          // if only retail card is adding and benefit card is deleting
          updateShowCheckbox(false);
          updateShowSetBackup(true);
          updateChecked(true);
          updateShowSetDefault(false);
          updateDisableCheckbox(false);
        } else if (isRetail && checkForExistingPrimaryRetail()) {
          // if only retail card is adding and existing retail card is deleting
          updateShowCheckbox(false);
          updateShowSetDefault(true);
          updateChecked(true);
        } else {
          // adding a federal/commuter as primary while deleting another benefit primary card
          updateShowCheckbox(false);
          updateShowSetDefault(true);
          updateDisableCheckbox(true);
          updateChecked(true);
        }
      } else {
        //Add card scenario
        // checking if no cards on file
        if ((props.cardDetails.federal === 0 && props.cardDetails.retail === 0) && (props.cardDetails.commuter === 0 && props.cardDetails.retail === 0)) {
          updateShowCheckbox(true);
          updateShowSetDefault(true);
          updateDisableCheckbox(true);
          updateChecked(true);
        } else if (props.cardDetails.primaryCards === 0) {
          updateShowCheckbox(true);
          updateShowSetDefault(true);
        }
        else {
          // if there are some cards

          if (isFederal !== null || isCommuter !== null) {
            if (isFederal === true || isCommuter === true) {
              updateShowCheckbox(true);
              updateShowSetDefault(true);
              updateChecked(true);
              updateDisableCheckbox(true);
              if(!checkForExistingPrimaryRetail()){
                updateShowConfirm(true);
              }
            }
            if (isFederal === false && isCommuter === false) {
              // If I am adding a retail card
              if (props.cardDetails.primaryCards && props.cardDetails.primaryCards[0] && (props.cardDetails.primaryCards[0].isFederalBenefitCard || props.cardDetails.primaryCards[0].isCommuterBenefitCard)) {
                // if There is a federal/commuter card on file
                if (isRetail) {
                  updateShowCheckbox(true);
                  updateShowSetBackup(true);
                 // updateShowSetDefault(true);
                 // updateShowBothChekbox(true);
                }
              } else if (isRetail) {
                updateShowCheckbox(true);
                updateShowSetDefault(true);
              } else {
                // if there is no federal/commuter card on file and also user did not yet select if its benefit or retail card
                updateShowCheckbox(false);
                //updateShowSetDefault(true);
              }
            }
          }
        }
      }
    }
  }, [props.cardDetails, isFederal, cardNumber, isCommuter, isRetail]);

  useEffect(() => {
    if (isFederal === true && (props.cardDetails.federal === 0 || (props.cardDetails.federal !== 0 && showSetDefault && checked))) {
      if (!mayBeFedCommuter) {
        updateShowFederalComponent(true);
      }
      // updateShowFederalCommuteRadio(false);

    } else {
      updateShowFederalComponent(false);
    }
  }, [isFederal, showSetDefault, checked, props.cardDetails]);

  useEffect(() => {
    const today = new Date();
    if (expirationDate.month && expirationDate.year && expirationDate.month < today.getMonth() + 1 && expirationDate.year <= today.getFullYear()) {
      updateDateValid(false);
    } else {
      updateDateValid(true);
    }
  }, [expirationDate]);

  function checkCVV(value) {
    const type = creditCardService.getCardTypeJoinCommute(cardNumber);
    if (creditCardService.isCvcValid(type.cvcLength, value)) {
      updateCvv(value);
    }
  }

  function checkZip(value) {
    if (/^\d{0,5}$/.test(value)) {
      updateZip(value);
      if (value.length === 5) {
        updateZipValid(true);
      } else {
        updateZipValid(false);
      }
    }
  }

  function checkCardNumber(value) {
    if (value.length >= 8) {
      const result = creditCardService.checkIfFederalOrCommuter(value, props.binNumbers, props.binNumberArray);
      // const isFederalCard = creditCardService.checkIfFederal(value, props.binNumbers);
      updateIsFederal(result.isFederal);
      if (!fedComuCardOnFile) {
        updateShowFederalComponent(result.isFederal);
      }
      updateMayBeFedCommuter(result.mayBeFedCommuter);
      updateMayBeRetailCommuter(result.mayBeRetailCommuter)
      updateShowFederalCommuteRadio(result.mayBeFedCommuter);
      updateShowRetailCommuteRadio(result.mayBeRetailCommuter);
      updateIsCommuter(false);
      // if(resultObject.mayBeCommuter){
      //   updateMayBeCommuter(resultObject.mayBeCommuter);
      //   updateShowFederalCommuteRadio(true)
      // }
    }
    else {
      updateIsFederal(false);
      updateMayBeFedCommuter(false);
      updateMayBeRetailCommuter(false);
      updateShowFederalCommuteRadio(false);
      updateShowRetailCommuteRadio(false);
      updateIsRetail(false);
      updateIsCommuter(false);
    }
    value = value.split(' ').join('');
    if (creditCardService.isNumber(value)) {
      const type = creditCardService.getCardTypeJoinCommute(value);
      updateCardType(type);
      value = value.substr(0, Math.max.apply(Math, type.length));
      updateCardNumber(value);
    }
  }

  function checkCardInfoValid(cardNumber, cardType, cvv) {
    const isCVVValid = cardType && cvv && cvv.length === cardType.cvcLength;
    if (cvv) {
      updateCvvValid(isCVVValid);
    }
    const isCardNumberValid = cardType && cardNumber && cardType.length.includes(cardNumber.length);
    const isLunh = creditCardService.luhn(cardNumber);
    if (cardNumber && cardType) {
      updateCardValid(isCardNumberValid && cardType.type !== '' && isLunh);
    } else {
      updateCardValid(true);
    }
    return !!isCVVValid && isCardNumberValid && isLunh;
  }

  useEffect(() => {
    const alreadyFedCardOnFile = props.cardDetails && props.cardDetails.primaryCards && props.cardDetails.primaryCards[0] && (props.cardDetails.primaryCards[0].isCommuterBenefitCard || props.cardDetails.primaryCards[0].isFederalBenefitCard)
    const isValid = checkCardInfoValid(cardNumber, cardType, cvv, zip);
    var federalValidation;
    if (isFederal && !isCommuter && !mayBeFedCommuter && !mayBeRetailCommuter) {
      federalValidation = ((showSetDefault && checked && !!authorizedAmount && isAmountValid)) || (props.isDeleteScenario && showSetDefault && checked && !!authorizedAmount && isAmountValid)
    } else if (mayBeFedCommuter || mayBeRetailCommuter) {
      if ((isFederal || isCommuter) && !!authorizedAmount && isAmountValid) {
        federalValidation = true
      } else {
        federalValidation = false
      }
      if (isRetail) {
        federalValidation = true
      }

    } else {
      federalValidation = true
    }
    // const federalValidation = (isFederal || !isCommuter )  ? ((showCheckbox && showSetDefault && !checked) || (showCheckbox && showSetDefault && checked && !!authorizedAmount && isAmountValid)) : (mayBeFedCommuter || mayBeRetailCommuter) ? (( (isFederal || isCommuter ) && alreadyFedCardOnFile && showCheckbox && showSetDefault && !checked) || ( (isFederal || isCommuter ) && showCheckbox && showSetDefault && checked && !!authorizedAmount && isAmountValid) ) : true;
    if (cardNumber && cardType && cvv && zip && expirationDate && isValid && federalValidation && zipValid && dateValid) {
      updateButtonDisabled(false);
    } else {
      updateButtonDisabled(true);
    }
  }, [cardNumber, cardType, cvv, zip, expirationDate, isFederal, authorizedAmount, zipValid, dateValid, isAmountValid, checked, showCheckbox, showSetDefault, isCommuter, isRetail]);

  useEffect(() => {
    if (!cardValid || cardNumber === '') {
      checkCVV('');
      updateCvvDisabled(true);
    } else {
      updateCvvDisabled(false);
    }
  }, [cardValid, cardNumber]);

  function onContinue() {
    props.addCard({
      cardNumber,
      cardType,
      cvv,
      expirationDate,
      zip,
      isFederal,
      isBackup: showSetBackup && checked,
      isDefault: showSetDefault && checked,
      maxAuthorizedAmount: authorizedAmount,
      isCommuter,
      isRetail,
      mayBeFedCommuter,
      mayBeRetailCommuter
    });

    analyticsService.analyticsProcessEvent({
      "event": "click_generic",
      "context": {
        "event_action": "continue"
      }
    });
  }

  function onContinueClicked() {
    if(props.deletingRetailPrimary && !isFederal && !isCommuter){
      props.showAddReplacementConfirm({
        cardNumber,
        cardType,
        cvv,
        expirationDate,
        zip,
        isFederal,
        isBackup: showSetBackup && checked,
        isDefault: showSetDefault && checked,
        maxAuthorizedAmount: authorizedAmount,
        isCommuter,
        isRetail,
        mayBeFedCommuter,
        mayBeRetailCommuter
      });
    }else{
      onContinue();
    }
  }

  useEffect(() => {
    if (props.reference.current) {
      props.reference.current.focus();
    }
  }, []);

  const keyDownHandler = (e) => {
    if (e.keyCode === TAB_KEY_CODE) {
      e.preventDefault();
      const firstFocusElement = document.getElementById('close-icon');
      firstFocusElement?.focus();
    } else {
      onContinueClicked();
    }
  }

  function getCommuter() {
    if (props.cardDetails && props.cardDetails.commuter > 0 && props.cardDetails.primaryCards && props.cardDetails.primaryCards[0] && props.cardDetails.primaryCards[0].isCommuterBenefitCard) {
      return true;
    } else {
      return false;
    }
  }

  const toggleSecondaryCheckBox = () => {
    setSecondaryChecked(!secondaryChecked);
    if (!secondaryChecked) {
      updateChecked(false);
    }

    // Add any additional logic needed when toggling the secondary card
  };

  // const cancelConfirm = () => {
  //   updateShowReplacementConfirm(false);
  //   props.close();
  // }

  return (
    <div className='card-operations-container' ref={props.reference} aria-modal='true' role='dialog' aria-describedby='heading'>
      <div className='header'>
        <div className='heading' id='heading'>Add payment</div>
        <img id='close-icon' className='close' role='button' src={Close} onKeyDown={props.close} tabIndex={0} onClick={props.close} alt='close icon' />
      </div>
      <div className='sub-heading'>Card Information</div>
      <CardInformation
        ref={props.reference}
        cardType={cardType}
        cardValid={cardValid}
        cardNumber={cardNumber}
        expirationDate={expirationDate}
        checkCardNumber={checkCardNumber}
        onDateChange={onDateChange}
        cvv={cvv}
        checkCVV={checkCVV}
        zip={zip}
        checkZip={checkZip}
        cvvValid={cvvValid}
        isCvvDisabled={isCvvDisabled}
        zipValid={zipValid}
        dateValid={dateValid}
        focus={true}
        showConfirm={showConfirm}
      />
      {/* 
      {
        showFederalCommuteRadio && 
        <FederalOrCommuterRadio
         isFederal={isFederal}
         isCommuter={isCommuter}
         updateIsFederal={updateIsFederal}
         updateIsCommuter={updateIsCommuter}
         authorizedAmount={authorizedAmount}
         onUpdateAuthorizedAmount={updateAuthorizedAmount}
         updateIsAmountValid={updateIsAmountValid}
         maxAmount={props.maxAmount}
         isAmountValid={isAmountValid}
        />

      } */}

      {/* Contnue with Federal */}

      {isFederal && showFederalComponent && <FederalComponent
        authorizedAmount={authorizedAmount}
        onUpdateAuthorizedAmount={updateAuthorizedAmount}
        updateIsAmountValid={updateIsAmountValid}
        maxAmount={props.maxAmount}
        isAmountValid={isAmountValid}
        isCvvZipValid={(!zipValid && !cvvValid)}
        isCommuter={isCommuter}
        header={true} />}

      {/* Checking for Federal or Commuter */}
      {
        mayBeFedCommuter && showFederalCommuteRadio &&
        <FederalOrCommuterRadio
          isFederal={isFederal}
          isCommuter={isCommuter}
          updateIsFederal={updateIsFederal}
          updateIsCommuter={updateIsCommuter}
          authorizedAmount={authorizedAmount}
          onUpdateAuthorizedAmount={updateAuthorizedAmount}
          updateIsAmountValid={updateIsAmountValid}
          maxAmount={props.maxAmount}
          isAmountValid={isAmountValid}
        />

      }
      {/* Checking for Retail or Commuter */}
      {
        mayBeRetailCommuter && showRetailCommuteRadio &&
        <RetailOrCommuterRadio
          isRetail={isRetail}
          isCommuter={isCommuter}
          updateIsRetail={updateIsRetail}
          updateIsCommuter={updateIsCommuter}
          authorizedAmount={authorizedAmount}
          onUpdateAuthorizedAmount={updateAuthorizedAmount}
          updateIsAmountValid={updateIsAmountValid}
          maxAmount={props.maxAmount}
          isAmountValid={isAmountValid}
        />
      }


      {showCheckbox && <CardCheckBox
        checked={checked}
        toggleCheckBox={toggleCheckBox}
        setDefault={showSetDefault}
        setBackup={showSetBackup}
        disabled={disableCheckbox}
        isCommuter={getCommuter()}
      />}

      {/* {
        showBothChekbox && (

          <>
            <CardCheckBox
              checked={checked}
              toggleCheckBox={toggleCheckBox}
              setDefault={true}  // Always show as default card
              setBackup={false}
              disabled={disableCheckbox}
              isCommuter={getCommuter()}
            // label="Set as primary card"  // You might want to add this prop to your CardCheckBox component
            />
            <CardCheckBox
              checked={secondaryChecked}  // You'll need to manage this state
              toggleCheckBox={toggleSecondaryCheckBox}  // You'll need to create this handler
              setDefault={false}
              setBackup={true}  // Show as secondary/backup
              disabled={disableCheckbox}
              isCommuter={getCommuter()}
            //  label="Set as secondary card"
            />
          </>
        )
      } */}


      {/* {!showFederalCommuteRadio && isFederal && showFederalComponent && <FederalComponent
        authorizedAmount={authorizedAmount}
        onUpdateAuthorizedAmount={updateAuthorizedAmount}
        updateIsAmountValid={updateIsAmountValid}
        maxAmount={props.maxAmount}
        isAmountValid={isAmountValid} />} */}

      <LegalCopy isFederal={isFederal} />
      <button id='continue-button' disabled={buttonDisabled} className='continue-button' onClick={onContinueClicked} onKeyDown={keyDownHandler}>continue</button>

      {/* {
        showReplacementConfirm && <CardReplacementConfirmPopup onContinue={() => onContinue()}  close={() => cancelConfirm()}/>
      } */}
    </div>
  );
}

export default AddCard;
